export default __webpack_public_path__ + "images/Four_Chamber_View_of_the_Heart_dark.85ec476d1b2028655be92ee3aa8493be.png";